import React, { useState, useEffect, useRef } from "react";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Zoom from "@material-ui/core/Zoom";
import { makeStyles } from "@material-ui/core/styles";

const useLinearProgressStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        borderRadius: "8px",
        height: "7px",
        marginTop: "auto",
        marginBottom: "auto",
        "& .MuiLinearProgress-bar": {
            backgroundColor: "#15A671",
        },
    },
}));

const MiniProgress = (props) => {
    const {
        delay,
        incrementCompletedCount,
    } = props;

    const linearProgressStyles = useLinearProgressStyles();
    const [showCheckIcon, setShowCheckIcon] = useState(false);
    const [progress, setProgress] = useState(0);

    const incrementCount = useRef(() => {
        setTimeout(() => {
            incrementCompletedCount();
        }, 1250);
    });

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    setTimeout(() => {
                        setShowCheckIcon(true);
                    }, 300);
                    return oldProgress;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, delay*100);

        return () => clearInterval(intervalId);
    }, [delay]);

    useEffect(() => {
        if (progress === 100) {
            incrementCount.current();
        }
    }, [progress]);

    return (
        <Box
            width="100%"
            position="absolute"
            top="7px"
        >
            <Box display="flex">
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    classes={linearProgressStyles}
                />
                <Zoom in={showCheckIcon}>
                    <CheckCircleIcon
                        style={{
                            fill: "#16C686",
                            marginLeft: "8px",
                            visibility: (showCheckIcon)
                                ? "visible"
                                : "hidden",
                        }}
                    />
                </Zoom>
            </Box>
        </Box>
    );
};

export default MiniProgress;